export { PluginExtensionRegistry } from "./PluginExtensionRegistry";
export { PluginLocaleRegistry } from "./PluginLocaleRegistry";
export { PluginMenuRegistry } from "./PluginMenuRegistry";
